import React from 'react';
import {
  Field,
} from 'formik';
import { numToLetter } from '~/commons/helpers';

const FieldsSingleSelect = ({
  qtnIndex: i,
  question: q,
  answered,
  isCorrect,
  correctAns: cAns,
  disabled = false,
}) => (
  <div>
    {/* answer */}
    {/* {q.choices.map((c, ii) => (
      <div key={ii} className="mb-2">
        <FormCheckGroup
          className="mb-2"
          name={`answers.${i}.answered`}
          type="radio"
          label={`${numToLetter(ii, true)}. ${c}`}
          value={ii.toString()}
          disabled={disabled}
        />
      </div>
    ))} */}
    {q.choices.map(({ c, ii }, jj) => {
      // Handle both string and object format for choices
      const choiceText = typeof c === 'string' ? c : c.text;
      const choiceImg = typeof c === 'object' ? c.img : null;

      return (
        <div key={ii} className="mb-2">
          <div className="row">
            <div className="col-auto pr-0" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Field name={`answers.${i}.answered`}>
                {({ field }) => (
                  <div
                    onClick={() => !disabled && field.onChange({
                      target: { name: field.name, value: ii.toString() },
                    })}
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      border: '2px solid #ff8c42',
                      backgroundColor: field.value === ii.toString() ? '#ff8c42' : 'transparent',
                      cursor: disabled ? 'default' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {field.value === ii.toString() && (
                      <div
                        style={{
                          width: '8px',
                          height: '8px',
                          borderRadius: '50%',
                          backgroundColor: 'white',
                        }}
                      />
                    )}
                  </div>
                )}
              </Field>
              <label style={{
                color: '#ff8c42',
                fontWeight: 'bold',
                fontSize: '16px',
                cursor: disabled ? 'default' : 'pointer',
                userSelect: 'none',
              }} onClick={() => !disabled && document.querySelector(`input[name="answers.${i}.answered"][value="${ii}"]`).click()}>
                {`${numToLetter(jj, true)}.`}
              </label>
            </div>
            <div className="col">
              <Field name={`answers.${i}.answered`}>
                {({ field }) => (
                  <label
                    htmlFor={`rb_${i}_${ii}`}
                    className="form-check-label"
                    onClick={() => !disabled && field.onChange({
                      target: { name: field.name, value: ii.toString() },
                    })}
                    style={{
                      cursor: disabled ? 'default' : 'pointer',
                      userSelect: 'none',
                    }}
                  >
                    {choiceText}
                    {choiceImg && (
                      <div className="mt-2">
                        <img
                          src={choiceImg}
                          alt={choiceText || `Choice ${jj + 1}`}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                            display: 'block',
                          }}
                          className="img-fluid"
                        />
                      </div>
                    )}
                  </label>
                )}
              </Field>
            </div>
          </div>
        </div>
      );
    })}
    {/* answered */}
    {answered !== undefined && (
      <div className={`
        mt-3 py-2 px-4 position-relative
        ${
          cAns !== undefined && !isCorrect
            ? 'bg-light' : 'bg-quinary'
        }
      `}>
        我的答案:
        &nbsp;
        {(() => {
          const choice = q.choices.find(({ ii }) => String(ii) === String(answered));
          if (answered === undefined || !choice) return '未選擇';
          const idx = q.choices.indexOf(choice);
          return numToLetter(idx, true);
        })()}
        {/* correct/incorrect mark */}
        {cAns !== undefined && (
          <img
            className="pos-abs-br mr-3 mb-2"
            {...isCorrect ? {
              src: '/assets/img/correct.svg',
              style: { width: '42px', height: '36px' },
            } : {
              src: '/assets/img/incorrect.svg',
              style: { width: '34px', height: '40px' },
            }}
          />
        )}
      </div>
    )}
    {/* correct answer */}
    {(cAns !== undefined && !isCorrect) && (
      <div className="text-tertiary mt-3 py-2 px-4">
        正確答案:
        &nbsp;
        {(() => {
          const choice = q.choices.find(({ ii }) => String(ii) === String(cAns));
          if (cAns === undefined || !choice) return '無';
          const idx = q.choices.indexOf(choice);
          return numToLetter(idx, true);
        })()}
      </div>
    )}
  </div>
);

export default FieldsSingleSelect;
